import React from "react";
import { FormHelperText } from "@mui/material";
import { Controller } from "react-hook-form";
import CountryCodePicker from "../../CountryCodePicker";

const getErrorMessage = (errors, name) => {
  if (!errors) return "";
  if (typeof errors === "string") return errors;
  return name
    .split(".")
    .reduce((value, key) => value?.[key], errors)?.message || "";
};

const FormCountryPicker = ({
  name,
  control,
  errors,
  disabled = false,
  size = "compact",
}) => {
  const errorMessage = getErrorMessage(errors, name);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <CountryCodePicker
            name={field.name}
            value={field.value || "+91"}
            onChange={(nextValue) => field.onChange(nextValue)}
            onBlur={field.onBlur}
            disabled={disabled}
            error={!!errorMessage}
            size={size}
          />
        )}
      />
      {errorMessage && (
        <FormHelperText error sx={{ mt: 0.5, mx: 0 }}>
          {errorMessage}
        </FormHelperText>
      )}
    </>
  );
};

export default FormCountryPicker;
